<template>
  <div class="m-pop">
    <van-search placeholder="请输入搜索关键词" v-model="searchWord"/>
    <van-tabs v-model="tabActive" :line-width="20">
      <van-tab title="推荐项目"
               v-if=" productRecommend.basePackagePros && productRecommend.basePackagePros.data && (productRecommend.basePackagePros.data.length || productRecommend.rulePackagePros.data.length || productRecommend.lastRulePackagePros.data.length) || relevantProject.counditionInfoList.length ">
        <div style="width: 100%;overflow: hidden">
        <div class="relevantCoundition row" v-if="relevantProject.projectList && relevantProject.projectList.length"
          >
          <div class="col-auto"><i class="icon icon-jinggao assertive vertical-align-middle"></i> <span class="vertical-align-middle">与您相关</span></div>
          <div class="col white-space-nowrap overflow-hidden counditionInfoListBox" v-show="relevantProject.counditionInfoList && relevantProject.counditionInfoList.length">
            <div class="row row-wrap"><span v-for="item in relevantProject.counditionInfoList" :key="'coun'+item.id"
                                            class="counditionItem col-auto" @click="filterCoundition(item)"
                                            :class="{'active': counditionId === item.id}">{{item.name}}</span></div>
          </div>
          <i class="icon icon-arrow-right col-auto" @click.stop="showFilterCoundition()"    v-show="relevantProject.counditionInfoList && relevantProject.counditionInfoList.length"></i>

        </div>
        <div class="m-cont" v-show="relevantProject.projectList && relevantProject.projectList.length">
          <div class="m-child-box"
          >
            <!--是目录--1-->
            <template v-for="(project,index) in relevantProject.projectList">

              <project type="checkbox" :project="project" :checkedList="checkedList" :key="'relevantProject'+index"
                       :recommend="true" :showStar="true"
                       @iconClicked="showProjectDetail"
                       v-show=" projectFilter[project.id]===true && (!counditionId || relevantProject.counditionInfoId[counditionId].includes(project.id))"></project>
              <!--</template>-->
            </template>
          </div>
        </div>
        <!--<div>{{relevantProject.counditionInfoList}}</div>-->
        <div class="recommendTitle relevantCoundition row">
          <div class="col-auto"><i class="icon icon-tuijian assertive assertive"></i>更多推荐</div>
        </div>
        <div class="productRecommend" id="basic-inspection-items-t">
          <div class="m-cont" v-if="productRecommend.basePackagePros.data.length>0"
               :key="productRecommend.basePackagePros.id">
            <div class="affix-block">
              <affix :relative-element-selector="'#basic-inspection-items-t'"
                     :offset="{ top: 0, bottom: 0 }">
                <div class="m-item m-item-hasBefore">
                <span @click="openItem(item)">
                  基础检查项目 <span class="projectStar star-5"></span></span>
                  <div class="m-btn-group" v-show="itemActive.includes(productRecommend.basePackagePros.id)">
                    <button class="no-border" @click="openItem(productRecommend.basePackagePros)"> 收起 <i
                        class="icon arrow icon-arrow-top"
                    ></i></button>
                  </div>
                </div>
              </affix>
            </div>
            <div class="reminder">
              指当前年龄段，满足您身体最基本检查的体检项目，一般不建议删除！
            </div>
            <div :id="productRecommend.basePackagePros.id" class="m-child-box"
                 :class="itemActive.includes(productRecommend.basePackagePros.id) && productRecommend.basePackagePros.data.length> 2?'':'closed showTwo'">
              <!--是目录--1-->
              <template v-for="(project,index) in productRecommend.basePackagePros.data">
                <div class="m-hint" :class="{'mutex-group':project.typable === '1'}"
                     v-if="project.typable === '1' && productSubRecommend.basePackagePros[project.id]"
                     :key="project.id" v-show="projectFilter[project.id]===true ">
                  <div>
                    <span> 以下{{productSubRecommend.basePackagePros[project.id] && productSubRecommend.basePackagePros[project.id].length}}项同类检查，请选其一</span>
                  </div>

                  <div class="m-child-box">
                    <template v-for="(mutexProject,index) in productSubRecommend.basePackagePros[project.id]">
                      <project type="radio" :project="mutexProject" :checkedList="checkedList" :mutexId="project.id"
                               :recommend="true"
                               @iconClicked="showProjectDetail" :key="index"
                               v-show="projectFilter[mutexProject.id]===true"></project>
                    </template>
                  </div>
                </div>
                <!--是项目0-->
                <template v-if="project.typable === '0'">
                  <project type="checkbox" :project="project" :checkedList="checkedList" :key="index" :recommend="true"
                           @iconClicked="showProjectDetail"
                           v-show="projectFilter[project.id]===true "></project>
                </template>
              </template>
            </div>
            <div class="m-btn-group text-center padding-10"
                 v-show="!itemActive.includes(productRecommend.basePackagePros.id) && productRecommend.basePackagePros.data.length> 2">
              <button class="no-border" @click="openItem(productRecommend.basePackagePros)"> 展开 <i
                  class="icon arrow icon-arrow-bottom"
              ></i></button>
            </div>
          </div>
        </div>
        <div class="productRecommend " id="recommend-must-check-items">
          <div class="m-cont" v-if="productRecommend.rulePackagePros.data.length>0"
               :key="productRecommend.rulePackagePros.id">
            <div class="affix-block">
              <affix :relative-element-selector="'#recommend-must-check-items'"
                     :offset="{ top: 0, bottom: 0 }">
                <div class="m-item m-item-hasBefore">
                <span @click="openItem(item)">
                  推荐必查项目<span class="projectStar star-4"></span>
                </span>

                  <div class="m-btn-group" v-if="itemActive.includes(productRecommend.rulePackagePros.id)">
                    <button class="no-border" @click="openItem(productRecommend.rulePackagePros)"> 收起 <i
                        class="icon arrow icon-arrow-top"
                    ></i></button>
                  </div>
                </div>
              </affix>
            </div>
            <div class="reminder">
              针对基础的项目升级，更符合体检需求
            </div>
            <div :id="productRecommend.rulePackagePros.id" class="m-child-box"
                 :class="itemActive.includes(productRecommend.rulePackagePros.id) && productRecommend.rulePackagePros.data.length> 2 ?'':'closed showTwo'">
              <!--是目录--1-->
              <template v-for="(project,index) in productRecommend.rulePackagePros.data">
                <div class="m-hint" :class="{'mutex-group':project.typable === '1'}"
                     v-if="project.typable === '1' && productSubRecommend.rulePackagePros[project.id]"
                     :key="project.id" v-show="projectFilter[project.id]===true">
                  <div>
                    <span> 以下{{productSubRecommend.rulePackagePros[project.id] && productSubRecommend.rulePackagePros[project.id].length}}项同类检查，请选其一</span>
                  </div>

                  <div class="m-child-box">
                    <template v-for="(mutexProject,index) in productSubRecommend.rulePackagePros[project.id]">
                      <project type="radio" :project="mutexProject" :checkedList="checkedList" :mutexId="project.id"
                               :recommend="true"
                               @iconClicked="showProjectDetail" :key="index"
                               v-show="projectFilter[mutexProject.id]===true"></project>
                    </template>
                  </div>
                </div>
                <!--是项目0-->
                <template v-if="project.typable === '0'">
                  <project type="checkbox" :project="project" :checkedList="checkedList" :key="index" :recommend="true"
                           @iconClicked="showProjectDetail"
                           v-show="projectFilter[project.id]===true"></project>
                </template>
              </template>
            </div>
            <div class="m-btn-group text-center padding-10"
                 v-if="!itemActive.includes(productRecommend.rulePackagePros.id) && productRecommend.rulePackagePros.data.length> 2 ">
              <button class="no-border" @click="openItem(productRecommend.rulePackagePros)"> 展开 <i
                  class="icon arrow icon-arrow-bottom"
              ></i></button>
            </div>
          </div>
        </div>
        <div class="productRecommend " id="in-depth-inspection-items">
          <div class="m-cont" v-if="productRecommend.lastRulePackagePros.data.length>0"
               :key="productRecommend.lastRulePackagePros.id">
            <div class="affix-block">
              <affix :relative-element-selector="'#in-depth-inspection-items'"
                     :offset="{ top: 0, bottom: 0 }">
                <div class="m-item m-item-hasBefore">
                <span @click="openItem(item)">
                  精准检查项目  <span class="projectStar star-3"></span></span>
                  <div class="m-btn-group" v-if="itemActive.includes(productRecommend.lastRulePackagePros.id)">
                    <button class="no-border" @click="openItem(productRecommend.lastRulePackagePros)"> 收起 <i
                        class="icon arrow icon-arrow-top"
                    ></i></button>
                  </div>
                </div>
              </affix>
            </div>
            <div class="reminder">
              针对推荐的项目升级，让体检更精准
            </div>
            <div :id="productRecommend.lastRulePackagePros.id" class="m-child-box"
                 :class="itemActive.includes(productRecommend.lastRulePackagePros.id)  && productRecommend.lastRulePackagePros.data.length> 2 ?'':'closed showTwo'">
              <!--是目录--1-->
              <template v-for="(project,index) in productRecommend.lastRulePackagePros.data">
                <div class="m-hint" :class="{'mutex-group':project.typable === '1'}"
                     v-if="project.typable === '1' && productSubRecommend.lastRulePackagePros[project.id]"
                     :key="project.id" v-show="projectFilter[project.id]===true">
                  <div>
                    <span>以下{{productSubRecommend.lastRulePackagePros[project.id] && productSubRecommend.lastRulePackagePros[project.id].length}}项同类检查，请选其一</span>
                  </div>

                  <div class="m-child-box">
                    <template v-for="(mutexProject,index) in productSubRecommend.lastRulePackagePros[project.id]">
                      <project type="radio" :project="mutexProject" :checkedList="checkedList" :mutexId="project.id"
                               :recommend="true"
                               @iconClicked="showProjectDetail" :key="index"
                               v-show="projectFilter[mutexProject.id]===true"></project>
                    </template>
                  </div>
                </div>
                <!--是项目0-->
                <template v-if="project.typable === '0'">
                  <project type="checkbox" :project="project" :checkedList="checkedList" :key="index" :recommend="true"
                           @iconClicked="showProjectDetail"
                           v-show="projectFilter[project.id]===true "></project>
                </template>
              </template>
            </div>
            <div class="m-btn-group text-center  padding-10"
                 v-if="!itemActive.includes(productRecommend.lastRulePackagePros.id)  && productRecommend.lastRulePackagePros.data.length> 2 ">
              <button class="no-border" @click="openItem(productRecommend.lastRulePackagePros)"> 展开 <i
                  class="icon arrow icon-arrow-bottom"
              ></i></button>
            </div>
          </div>
        </div>
        <div class="productRecommend " id="in-depth-thorough-items">
          <div class="m-cont" v-if="productRecommend.thoroughRulePackagePros.data.length>0"
               :key="productRecommend.thoroughRulePackagePros.id">
            <div class="affix-block">
              <affix :relative-element-selector="'#in-depth-thorough-items'"
                     :offset="{ top: 0, bottom: 0 }">
                <div class="m-item m-item-hasBefore">
                <span @click="openItem(item)">
                 深入检查项目  <span class="projectStar star-2"></span></span>
                  <div class="m-btn-group" v-if="itemActive.includes(productRecommend.thoroughRulePackagePros.id)">
                    <button class="no-border" @click="openItem(productRecommend.thoroughRulePackagePros)"> 收起 <i
                        class="icon arrow icon-arrow-top"
                    ></i></button>
                  </div>
                </div>
              </affix>
            </div>
            <div class="reminder">
              针对精准的项目升级，让体检更全面
            </div>
            <div :id="productRecommend.thoroughRulePackagePros.id" class="m-child-box"
                 :class="itemActive.includes(productRecommend.thoroughRulePackagePros.id) && productRecommend.thoroughRulePackagePros.data.length> 2 ?'':'closed showTwo'">
              <!--是目录--1-->
              <template v-for="(project,index) in productRecommend.thoroughRulePackagePros.data">
                <div class="m-hint" :class="{'mutex-group':project.typable === '1'}"
                     v-if="project.typable === '1' && productSubRecommend.thoroughRulePackagePros[project.id]"
                     :key="project.id" v-show="projectFilter[project.id]===true">
                  <div>
                    <span>以下{{productSubRecommend.thoroughRulePackagePros[project.id] && productSubRecommend.thoroughRulePackagePros[project.id].length}}项同类检查，请选其一</span>
                  </div>

                  <div class="m-child-box">
                    <template v-for="(mutexProject,index) in productSubRecommend.thoroughRulePackagePros[project.id]">
                      <project type="radio" :project="mutexProject" :checkedList="checkedList" :mutexId="project.id"
                               :recommend="true"
                               @iconClicked="showProjectDetail" :key="index"
                               v-show="projectFilter[mutexProject.id]===true"></project>
                    </template>
                  </div>
                </div>
                <!--是项目0-->
                <template v-if="project.typable === '0'">
                  <project type="checkbox" :project="project" :checkedList="checkedList" :key="index" :recommend="true"
                           @iconClicked="showProjectDetail"
                           v-show="projectFilter[project.id]===true"></project>
                </template>
              </template>
            </div>
            <div class="m-btn-group text-center padding-10"
                 v-if="!itemActive.includes(productRecommend.thoroughRulePackagePros.id) && productRecommend.thoroughRulePackagePros.data.length> 2 ">
              <button class="no-border" @click="openItem(productRecommend.thoroughRulePackagePros)"> 展开 <i
                  class="icon arrow icon-arrow-bottom"
              ></i></button>
            </div>
          </div>
        </div>
        </div>
      </van-tab>
      <van-tab title="全部">
        <div class="m-cont" v-for="item in projectList " v-show="projectFilter[item.id]===true"
             :key="item.id">
          <div class="affix-block">
            <affix :relative-element-selector="'#p'+item.id"
                   :offset="{ top: 50, bottom: 0 }">
              <div class="m-item" :sid="'#p'+item.id">
                <span @click="openItem(item)">
                   <img src="../../../public/images/filesIcon.png" v-if="itemActive.includes(item.id)" alt="">
                   <img src="../../../public/images/filesIconClose.png" v-else alt="">
                  {{item.item}}</span>
                <div class="m-btn-group">
                  <button class="no-border" @click="openItem(item)"> {{itemActive.includes(item.id) ? '收起' : '展开'}} <i
                      class="icon arrow"
                      :class="itemActive.includes(item.id) ?'icon-arrow-top':'icon-arrow-bottom'"
                  ></i></button>
                </div>
              </div>
            </affix>
          </div>
          <div :id="'p'+item.id" class="m-child-box" :class="itemActive.includes(item.id)?'':'closed'">
            <!--是目录--1-->
            <template v-for="(project,index) in item.children">
              <div class="m-hint" :class="{'mutex-group':project.typable === '1'}"
                   v-if="project.typable === '1' && project.visible === 1"
                   :key="project.id + '-' + index" v-show="projectFilter[project.id]===true">
                <div>
                  <span>{{project.item}}</span>
                </div>

                <div class="m-child-box">
                  <template v-for="(mutexProject,index) in project.children">
                    <project type="radio" :project="mutexProject" :checkedList="checkedList" :mutexId="project.id"
                             @iconClicked="showProjectDetail" :key="project.id + '-'+ index"
                             v-show="projectFilter[mutexProject.id]===true"></project>
                  </template>
                </div>
              </div>
              <!--是项目0-->
              <template v-if="project.typable === '0'">
                <project type="checkbox" :project="project" :checkedList="checkedList" :key="index"
                         @iconClicked="showProjectDetail"
                         v-show="projectFilter[project.id]===true"></project>
              </template>
            </template>
          </div>
        </div>
      </van-tab>
      <van-tab title="专项筛查">
        <div class="m-cont" v-for="item in projectClassList "
             :key="item.id" v-show="projectFilter[item.id]">
          <div class="affix-block">
            <affix :relative-element-selector="'#pc'+item.id"
                   :offset="{ top: 50, bottom: 0 }">
              <div class="m-item">
                <span class="m-btn-group"><span @click="openItem(item)">
                  <img src="../../../public/images/filesIcon.png" alt="" v-if="itemActive.includes(item.id)">
                    <img src="../../../public/images/filesIconClose.png" v-else alt="">
                  {{item.item}}</span><button
                    @click.stop="projectClassGroupClicked(item)"
                    :class="{blueText: all(item)}"
                    v-show="itemActive.includes(item.id)">全选</button></span>
                <div class="m-btn-group">
                  <button class="no-border" @click="openItem(item)"> {{itemActive.includes(item.id) ? '收起' : '展开'}} <i
                      class="icon arrow"
                      :class="itemActive.includes(item.id) ?'icon-arrow-top':'icon-arrow-bottom'"
                  ></i></button>
                </div>
              </div>
            </affix>
          </div>
          <div :id="'pc'+item.id" class="m-child-box" :class="itemActive.includes(item.id)?'':'closed'">
            <!--是目录--1-->
            <template v-for="(project,index) in item.items">
              <div class="m-hint" :class="{'mutex-group':project.typable === '1'}"
                   v-if="project.typable === '1' && projectFilter[project.id]" :key="index">
                {{project.mutexItem}}
                <div class="m-child-box">
                  <template v-for="(mutexProject,indx) in project.children">
                    <project type="radio" :project="mutexProject" :checkedList="checkedList" :mutexId="project.id"
                             @iconClicked="showProjectDetail" :key=" 'mutexProject' + indx "
                             v-show="projectFilter[project.id]"></project>
                  </template>
                </div>
              </div>
              <!--是项目0-->
              <template v-if="project.typable === '0'">
                <project type="checkbox" :project="project" :checkedList="checkedList" :key="index + '_cj2'"
                         @iconClicked="showProjectDetail" v-show="projectFilter[project.id]"></project>
              </template>
            </template>
          </div>
        </div>
        <div class="text-center padding found" v-if="projectClassList.length === 0 ">
          无专项筛查项目包
        </div>
      </van-tab>
    </van-tabs>
    <project-description :showModal="showProjectModal" :project="projectDetail"
                         @iconClicked="closeProjectDetail" @maskClicked="closeProjectDetail"></project-description>
    <van-popup v-model="showCountList" @click-overlay="showFilterCoundition" position="bottom" class="allCoundition">
      <template>
        <h3 class="title">存在的问题</h3>
        <div class="row">
          <div class="col">
            <div class="row row-wrap">
              <span v-for="item in relevantProject.counditionInfoList"
                    :key="'coun'+item.id" class="counditionItem col-auto" @click="filterCoundition(item)"
                    :class="{'active': counditionId === item.id}">{{item.name}}</span></div>
          </div>
        </div>
        <button @click="showFilterCoundition">关闭</button>
      </template>
    </van-popup>
    <div class="m-foot">
      <div class="m-info">
        <p class="m-info-left">项目金额：<span>￥<b>{{priceInfo.priceTotal}}</b></span></p>
      </div>
      <div class="m-next" @click="closeBox()">确定并返回</div>
    </div>
  </div>
</template>

<script>
import { Tab, Tabs, Collapse, CollapseItem, Search } from 'vant'
import { project, projectDescription } from '@/components/common'
import Vue from 'vue'
import jumper from '@/assets/scripts/jumper'
import { mapGetters } from 'vuex'
import { Affix } from 'vue-affix'

Vue.use(Tab).use(Tabs).use(Collapse).use(CollapseItem).use(Search)
export default {
  components: {
    project,
    Affix,
    projectDescription
  },
  data () {
    return {
      showCountList: false,
      showProjectModal: false,
      counditionId: '',
      projectDetail: {},
      searchWord: '',
      tabActive: 0,
      itemActive: [],
      tabItems: [
        {name: '全部', id: 'report'},
        {name: '推荐', id: 'result'}
      ]
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'appointmentConfirm') {
      next(true)
    } else {
      next(false)
    }
  },
  methods: {
    showFilterCoundition () {
      this.showCountList = !this.showCountList
    },
    //      maskClicked(){
    //      this.showCountList =false
    //      },
    filterCoundition (item) {
      if (this.counditionId !== item.id) { this.counditionId = item.id } else { this.counditionId = '' }
    },
    all (item) {
      let str = false
      let arr = this.getSpecialAllList(item.id)
      for (let obj of arr.values()) {
        for (let checked of this.checkedList.values()) {
          if (checked.id === obj) {
            str = true
          }
        }
      }
      return str
    },
    getSpecialAllList (strId) {
      let arr = []
      for (let obj of this.projectClassList.values()) {
        if (strId === obj.id) {
          obj.items.forEach(item => {
            if (item.visible !== 0) {
              if (item.children && item.children.length) {
                if (this.mutexProjectClass[`${strId}-${item.id}`]) {
                  this.mutexProjectClass[`${strId}-${item.id}`].forEach(value => {
                    if (value.visible !== 0) arr.push(value.id)
                  })
                }
              } else {
                arr.push(item.id)
              }
            }
          })
          return arr
        }
      }
    },
    showProjectDetail (project) {
      this.showProjectModal = true
      this.projectDetail = project
    },
    closeProjectDetail () {
      this.showProjectModal = false
    },
    closeBox () {
      this.$router.back()
    },
    openItem (item) {
      let index = this.itemActive.indexOf(item.id)
      if (index > -1) {
        this.itemActive.splice(index, 1)
      } else {
        this.itemActive.push(item.id)
      }
    },
    projectClassGroupClicked (item) {
      item.items.forEach(async project => {
        let uncheckProject
        if (project.typable === '1' && project.children.length > 0) {
          uncheckProject = project.children[0]
        } else if (project.typable === '0') {
          uncheckProject = project
        }
        if (!this.$store.state.project.checkedProjectList.some(p => uncheckProject.id === p.id)) {
          this.$store.commit('project/checkProject', uncheckProject)
        }
      })
      this.$store.commit('project/setProductProjects')
      this.$store.commit('project/setCheckedMaterialProjectList')
    }
  },
  computed: {
    relevantProject () {
      let counditionInfoList = []
      let projectList = JSON.parse(JSON.stringify(this.$store.state.project.rulePackageProsList))
      let counditionInfoId = {}

      projectList.map(project => {
        if (project.counditionInfoList && project.counditionInfoList.length) {
          project.counditionInfoList.forEach(obj => {
            if (!counditionInfoList.some($item => { return $item.id === obj.id })) {
              counditionInfoList.push(obj)
              counditionInfoId[obj.id] = []
            }
            if (!counditionInfoId[obj.id].includes(project.id)) counditionInfoId[obj.id].push(project.id)
          }
          )
        }
      }
      )
      projectList.sort((a, b) => { return b.star - a.star })
      return {counditionInfoList, projectList, counditionInfoId}
    },
    ...mapGetters({priceInfo: 'project/priceInfo'}),
    projectClassList () {
      return this.$store.state.project.projectClassList || []
    },

    productSubRecommend () {
      return this.$store.state.project.productSubRecommend || {}
    },

    projectList () {
      return this.$store.state.project.projectTreeList || []
    },

    productRecommend () {
      console.log(this.$store.state.project.productRecommend)
      return this.$store.state.project.productRecommend || {}
    },

    checkedList () {
      return this.$store.state.project.checkedProjectList || []
    },

    recommendProjectList () {
      return (this.$store.state.project && this.$store.state.project.recommendProjects) || []
    },

    subProjects () {
      return (this.$store.state.project && this.$store.state.project.recommendSubProjects) || []
    },

    mutexProjectClass () {
      return (this.$store.state.project && this.$store.state.project.mutexProjectClass) || {}
    },

    projectFilter () {
      let result = {}
      for (let item of this.projectList) {
        if (item.children && item.children.length) {
          for (let project of item.children) {
            if (project.typable === '1' && project.children && project.children.length > 0) {
              for (let subProject of project.children) {
                if (subProject.item.includes(this.searchWord) || this.searchWord == null) {
                  result[subProject.id] = true
                  result[project.id] = true
                  result[item.id] = true
                }
              }
            } else if (project.item.includes(this.searchWord) || this.searchWord == null) {
              result[project.id] = true
              result[item.id] = true
            }
          }
        } else {
          result[item.id] = false
        }
      }
      this.projectClassList.forEach(obj => {
        if (obj.items.some($item => { return result[$item.id] })) { result[obj.id] = true } else { result[obj.id] = false }
      })
      return result
    }

  },
  mounted () {
    //    this.tabActive= this.tabItems.findIndex(obj=>{return obj.id=== 'report'})
    //    console.log(this.tabActive)
    if (this.$store.state.project.currentClassGroupId) {
      this.tabActive = 1
      this.itemActive.push(this.$store.state.project.currentClassGroupId)

      window.setTimeout(() => {
        jumper.jump('#pc' + this.$store.state.project.currentClassGroupId, {offset: -55})
      }, 600)
    }
    if ((this.relevantProject.counditionInfoList && this.relevantProject.counditionInfoList.length) || (this.productRecommend.basePackagePros && this.productRecommend.basePackagePros.data && (this.productRecommend.basePackagePros.data.length || this.productRecommend.rulePackagePros.data.length || this.productRecommend.lastRulePackagePros.data.length))) { this.tabActive = 0 }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/scss" lang="scss" scoped>
  @import "@/assets/style/variables.scss";

  .m-pop {
    padding-bottom: 50px;
  }

  .m-input {
    width: 100%;
    height: 80px;
    text-align: center;
    > input {
      width: 80%;
      height: 40px;
      margin-top: 20px;
      padding: 0 20px;
      border-radius: 4px;
      border: 1px solid #f5f5f5;
      outline: 0;
      &:focus {
        outline: 0;
      }
    }
  }

  .m-cont {
    background-color: #ffffff;
  }

  .affix-block, .vue-affix {
    height: 50px;
    line-height: 50px;
    width: 100%;
  }

  .affix-bottom, .affix-top {
    z-index: 5
  }

  .affix {
    z-index: 5;
    left: 0px;
    padding: 0 10px;
    margin-right: 10px;
    .m-item, .m-alert-box {
      border-bottom: 1px solid $assertive;
    }
  }

  .m-item-hasBefore {
    span {
      font-weight: bold
    }
    padding-left: 35px !important;
    &:before {
      content: ' ';
      width: 5px;
      height: 14px;
      background: $assertive;
      position: absolute;
      top: 50%;
      margin-top: -7px;
      left: 15px;
    }
  }

  .m-item {
    height: 50px;
    line-height: 50px;
    padding-right: 15px;
    padding-left: 15px;
    border-bottom: 1px solid #f5f5f5;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-content: center;
    font-size: 15px;
    img {
      width: 25px;
      margin-right: 10px;
      position: relative;
      top: 1px;
    }
    .arrow {
      width: 40px;
      text-align: right;
    }

  }

  .m-btn-group {
    .arrow {
      font-size: 12px;
    }
    button {
      width: auto;
      height: 24px;
      line-height: 22px;
      padding: 0 10px;
      margin-left: 10px;
      border-radius: 12px;
      border: 1px solid $dark09;
      color: $dark06;
      background-color: #fff;
      font-size: 12px;
    }

  }

  .no-border {
    border-color: transparent !important;
  }

  .m-child-box {
    transition: height 400ms ease-in-out;
    -webkit-transition: height 400ms ease-in-out;
    .m-hint {
      line-height: 44px;
      padding-left: 20px;
      /*padding-right: 8px;*/
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      .icon {
        margin-right: 10px;
        font-size: 22px;
        color: #999999;
      }
      > span {
        display: flex;
        margin-right: 10px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 15px;
      }
    }
    .m-child-box {
      border-top: 1px solid #f5f5f5;
    }
    .mutex-group /deep/ {
      color: #666;
    }
  }

  .m-child-box.closed {
    transition: height 400ms ease-in-out;
    -webkit-transition: height 400ms ease-in-out;
    height: 0px;
    overflow: hidden;
  }

  .m-child-box.closed.showTwo {
    /*transition: height 400ms ease-in-out;*/
    /*-webkit-transition: height 400ms ease-in-out;*/
    height: 91px !important;
    /*overflow: hidden;*/
  }

  .m-alert-box {
    height: 50px;
    line-height: 50px;
    padding: 0 15px;
    border-bottom: 1px solid #f5f5f5;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-content: center;
    font-size: 15px;
  }

  .m-alert {
    width: 100%;
    margin: 6px 0;
    padding: 4px 8px;
    line-height: 34px;
    font-size: 13px;
    text-align: center;
    border-radius: 17px;
    background-color: #fff9f1;
    color: #fda42e;
  }

  .m-foot {
    display: flex;
    flex: 1;
    position: fixed;
    z-index: 10;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 50px;
    line-height: 50px;
    background-color: #ffffff;
    border-top: 1px solid #f5f5f5;
    .m-info {
      display: flex;
      flex: 1;
      padding-left: 15px;
      .m-info-left {
        flex: 1;
        font-size: 14px;
        > span {
          font-size: 12px;
          color: $assertive;
          > b {
            font-size: 24px;
          }
        }
      }
      .m-info-right {
        width: 80px;
        text-align: center;
        > i {
          padding: 0 10px;
        }
      }
    }
    .m-next {
      width: 110px;
      text-align: center;
      background-color: $assertive;
      font-size: 16px;
      color: #ffffff;
    }
  }

  .m-child-padding {
    margin: 0 10px;
  }

  .blueText {
    color: $light !important;
    border-color: $assertive !important;
    background-color: $assertive!important;
  }

  .productRecommend {
    /*padding: 10px;*/
    .m-cont {
      margin-top: 15px;
    }
  }

  .reminder {
    color: #fda42e;
    background-color: #fff9f1;
    margin: 10px 15px;
    padding: 5px 10px;
    border-radius: 5px;
  }

  .found {
    color: #999999;
    /*padding-top: 30px;*/
  }

  .relevantCoundition {
    /*width: 10rem;*/
    padding: 10px 15px;
    font-size: 14px;
    height: 46px;
    box-sizing: border-box;
    /*line-height: 36px;*/
    /*line-height: 36px;*/
    /*overflow: hidden;*/
    .icon {
      font-size: 20px;

    }

  }

  .recommendTitle {
    /*margin-top: 18px;*/
    padding-bottom: 0px;
    line-height: 46px;
  }

  .allCoundition /deep/ {
    /*height: 85%;*/
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    /*padding-bottom: 10px;*/
    /*overflow: hidden;*/
    padding: 15px;
    /*width: 90%;*/
    .title {
      text-align: center;
      padding-bottom: 20px;
    }
    button {
      display: block;
      margin: 15px auto;
      padding: 5px 30px;
      border: none;
      background: $dark09;
      color: $light;
      margin-bottom: 0px;
      /*margin-left:  20px;*/
      width: auto;
      border-radius: 5px;
    }
    /*background: transparent !important;*/
  }

  .counditionInfoListBox {
    /*line-height: 46px;*/
    overflow: hidden;
  }

  .counditionItem {
    color: $assertive;
    border: 1px solid $assertive;
    font-size: 13px;
    /*display: inline-block;*/
    padding: 1px 5px;
    margin: 0 5px;
    border-radius: 5px;
    margin-bottom: 8px;

  }

  .counditionItem.active {
    color: $assertive;
    background-color: $assertive;
    color: $light;
    /*<!--border:1px solid $assertive;-->*/
  }

  span.projectStar {
    position: relative;
    top: 3px;
    left: 10px;
  }

  .padding-10 {
    padding: 10px;
  }
</style>
